export const translations = {
  en: {
    navStory: "Our Story",
    navHowItWorks: "How it works",
    navTravel: "Travel Like a Local",
    heroTitle: "Float,",
    heroSubtitle1: "The app that",
    heroSubtitle2: "engages people to",
    heroSubtitle3: "travel like a local",
    heroJoin: "JOIN NOW",
    heroMeet: "and meet people",
    heroFrom: "from different cities",
    howItWorksTitle1: "How does the app help you find your",
    howItWorksTitle2: "local friend",
    method1Title1: "Send a Message",
    method1Title2: "in a Bottle",
    method1Desc: "We enable users to send messages in a bottle to their chosen cultural or language group. These messages float into the \"beach zone\", creating opportunities for authentic and serendipitous connections.",
    method2Title: "Discover Replies from Around the World",
    method2Desc: "Explore thoughtful replies to your bottles from native speakers and cultural enthusiasts. Engage in meaningful conversations that foster language learning and cultural exchange.",
    method3Title1: "Enjoy Floating",
    method3Title2: "Conversations",
    method3Desc: "Experience seamless communication through AI-powered auto-translation. Float connects you with people worldwide, breaking barriers and building bridges across cultures.",
    storytellersTitle: "Storytellers",
    storytellersSubtitle: "Share Local Treasures Through Our App",
    storytellersFeat1: "Share stories as \"漂流瓶\" (messages in a bottle).",
    storytellersFeat2: "Highlight hidden gems and cultural insights.",
    storytellersFeat3: "Build meaningful global connections.",
    travelersTitle: "Travelers",
    travelersSubtitle: "Explore Effortlessly, Connect Deeply",
    travelersFeat1: "Skip the hassle of planning—follow curated tours.",
    travelersFeat2: "Discover hidden gems through local insights.",
    travelersFeat3: "Immerse yourself in authentic cultural experiences.",
    featuresTitle: "How does the app help you find your local friend?",
    feature1Title: "Practical Language Learning",
    feature1Desc: "Float helps users practice casual and colloquial language, breaking intermediating and crumref terms for real-world use.",
    feature2Title: "Authentic Local Insights",
    feature2Desc: "Tourists can access genuine recommendations and eat suggestions from locals for a more enriching travel experience.",
    feature3Title: "Cultural Etiquette Guidance",
    feature3Desc: "Float provides cultural norms and etiquette tips from locals, helping travelers avoid faux pas and become respectful couraints.",
    footerPartnership: "Corporate partnership in queries:",
    footerSocial: "Social Media:",
    footerCopyright: "Copyright © 2025 Float"
  },
  zh: {
    navStory: "我们的故事",
    navHowItWorks: "如何运作",
    navTravel: "像当地人一样旅行",
    heroTitle: "Float，",
    heroSubtitle1: "让人们",
    heroSubtitle2: "参与其中",
    heroSubtitle3: "像当地人一样旅行",
    heroJoin: "立即加入",
    heroMeet: "结识来自",
    heroFrom: "不同城市的人们",
    howItWorksTitle1: "应用如何帮你找到你的",
    howItWorksTitle2: "本地朋友",
    method1Title1: "发送消息",
    method1Title2: "在瓶子里",
    method1Desc: "我们让用户能够向所选的文化或语言群体发送瓶中信。这些消息漂浮到\"海滩区\"，创造真实而偶然的联系机会。",
    method2Title: "发现来自世界各地的回复",
    method2Desc: "探索来自母语人士和文化爱好者对您瓶子的深思熟虑的回复。参与有意义的对话，促进语言学习和文化交流。",
    method3Title1: "享受漂浮",
    method3Title2: "对话",
    method3Desc: "通过人工智能驱动的自动翻译体验无缝沟通。Float将您与世界各地的人们联系起来，打破障碍，在文化之间架起桥梁。",
    storytellersTitle: "讲故事的人",
    storytellersSubtitle: "通过我们的应用分享当地宝藏",
    storytellersFeat1: "以\"漂流瓶\"的形式分享故事。",
    storytellersFeat2: "突出隐藏的宝石和文化见解。",
    storytellersFeat3: "建立有意义的全球联系。",
    travelersTitle: "旅行者",
    travelersSubtitle: "轻松探索，深度连接",
    travelersFeat1: "跳过规划的麻烦——跟随策划的旅游。",
    travelersFeat2: "通过当地见解发现隐藏的宝石。",
    travelersFeat3: "沉浸在真实的文化体验中。",
    featuresTitle: "应用如何帮你找到你的本地朋友？",
    feature1Title: "实用语言学习",
    feature1Desc: "Float帮助用户练习休闲和口语化的语言，打破中间术语以用于现实世界。",
    feature2Title: "真实的当地见解",
    feature2Desc: "游客可以从当地人那里获得真实的推荐和饮食建议，获得更丰富的旅行体验。",
    feature3Title: "文化礼仪指导",
    feature3Desc: "Float提供来自当地人的文化规范和礼仪提示，帮助旅行者避免失礼并成为尊重的游客。",
    footerPartnership: "企业合作咨询：",
    footerSocial: "社交媒体：",
    footerCopyright: "版权所有 © 2025 Float"
  },
  ja: {
    navStory: "私たちの物語",
    navHowItWorks: "使い方",
    navTravel: "地元の人のように旅行する",
    heroTitle: "Float、",
    heroSubtitle1: "人々を",
    heroSubtitle2: "参加させる",
    heroSubtitle3: "地元の人のように旅行",
    heroJoin: "今すぐ参加",
    heroMeet: "異なる都市から",
    heroFrom: "人々と出会う",
    howItWorksTitle1: "アプリはどのようにあなたを助けますか",
    howItWorksTitle2: "地元の友達",
    method1Title1: "メッセージを送る",
    method1Title2: "ボトルに入れて",
    method1Desc: "選択した文化や言語グループにボトルメッセージを送信できます。これらのメッセージは「ビーチゾーン」に浮かび、本物で偶然の出会いの機会を作り出します。",
    method2Title: "世界中からの返信を発見",
    method2Desc: "ネイティブスピーカーや文化愛好家からのボトルへの思慮深い返信を探索してください。言語学習と文化交流を促進する有意義な会話に参加してください。",
    method3Title1: "浮遊を楽しむ",
    method3Title2: "会話",
    method3Desc: "AI搭載の自動翻訳を通じてシームレスなコミュニケーションを体験してください。Floatは世界中の人々とあなたをつなぎ、障壁を打ち破り、文化を越えて橋を架けます。",
    storytellersTitle: "ストーリーテラー",
    storytellersSubtitle: "私たちのアプリを通じて地元の宝物を共有",
    storytellersFeat1: "「漂流瓶」としてストーリーを共有します。",
    storytellersFeat2: "隠れた宝石と文化的洞察を強調します。",
    storytellersFeat3: "意味のあるグローバルなつながりを構築します。",
    travelersTitle: "旅行者",
    travelersSubtitle: "楽に探索し、深くつながる",
    travelersFeat1: "計画の手間を省く—キュレーションされたツアーに従ってください。",
    travelersFeat2: "地元の洞察を通じて隠れた宝石を発見してください。",
    travelersFeat3: "本物の文化体験に浸ってください。",
    featuresTitle: "アプリはどのようにあなたの地元の友達を見つけるのを助けますか？",
    feature1Title: "実用的な言語学習",
    feature1Desc: "Floatはユーザーがカジュアルで口語的な言語を練習するのを助け、現実世界で使用するための中間用語を打ち破ります。",
    feature2Title: "本物の地元の洞察",
    feature2Desc: "観光客は地元の人々から本物の推奨事項や食事の提案にアクセスでき、より豊かな旅行体験を得られます。",
    feature3Title: "文化的エチケットガイダンス",
    feature3Desc: "Floatは地元の人々からの文化的規範とエチケットのヒントを提供し、旅行者が失礼を避け、敬意を払う観光客になるのを助けます。",
    footerPartnership: "企業提携のお問い合わせ：",
    footerSocial: "ソーシャルメディア：",
    footerCopyright: "著作権 © 2025 Float"
  },
  ko: {
    navStory: "우리의 이야기",
    navHowItWorks: "작동 방식",
    navTravel: "현지인처럼 여행하기",
    heroTitle: "Float，",
    heroSubtitle1: "사람들이",
    heroSubtitle2: "참여하도록",
    heroSubtitle3: "현지인처럼 여행",
    heroJoin: "지금 가입",
    heroMeet: "다른 도시에서",
    heroFrom: "사람들을 만나세요",
    howItWorksTitle1: "앱이 어떻게 도와주나요",
    howItWorksTitle2: "현지 친구",
    method1Title1: "메시지 보내기",
    method1Title2: "병에 담아",
    method1Desc: "선택한 문화 또는 언어 그룹에 병 속 메시지를 보낼 수 있습니다. 이 메시지는 \"해변 구역\"으로 떠다니며 진정하고 우연한 연결 기회를 만듭니다。",
    method2Title: "전 세계의 답변 발견",
    method2Desc: "원어민과 문화 애호가로부터 병에 대한 사려 깊은 답변을 탐색하세요. 언어 학습과 문화 교류를 촉진하는 의미 있는 대화에 참여하세요。",
    method3Title1: "떠다니는 것을 즐기세요",
    method3Title2: "대화",
    method3Desc: "AI 기반 자동 번역을 통해 원활한 의사 소통을 경험하세요. Float는 전 세계 사람들과 연결하여 장벽을 허물고 문화를 넘어 다리를 놓습니다。",
    storytellersTitle: "스토리텔러",
    storytellersSubtitle: "우리 앱을 통해 현지 보물 공유",
    storytellersFeat1: "\"漂流瓶\"로 이야기를 공유합니다。",
    storytellersFeat2: "숨겨진 보석과 문화적 통찰력을 강조합니다。",
    storytellersFeat3: "의미 있는 글로벌 연결을 구축합니다。",
    travelersTitle: "여행자",
    travelersSubtitle: "쉽게 탐색하고 깊이 연결",
    travelersFeat1: "계획의 번거로움을 건너뛰세요—큐레이션된 투어를 따라가세요。",
    travelersFeat2: "현지 통찰력을 통해 숨겨진 보석을 발견하세요。",
    travelersFeat3: "진정한 문화 체험에 몰입하세요。",
    featuresTitle: "앱이 현지 친구를 찾는 데 어떻게 도움이 되나요？",
    feature1Title: "실용적인 언어 학습",
    feature1Desc: "Float는 사용자가 캐주얼하고 구어적인 언어를 연습하도록 돕고 실제 사용을 위한 중간 용어를 깨뜨립니다。",
    feature2Title: "진정한 현지 통찰력",
    feature2Desc: "관광객은 현지인으로부터 진정한 추천과 식사 제안에 액세스하여 더 풍부한 여행 경험을 얻을 수 있습니다。",
    feature3Title: "문화 에티켓 지침",
    feature3Desc: "Float는 현지인의 문화 규범과 에티켓 팁을 제공하여 여행자가 실수를 피하고 존중하는 관광객이 되도록 돕습니다。",
    footerPartnership: "기업 파트너십 문의：",
    footerSocial: "소셜 미디어：",
    footerCopyright: "저작권 © 2025 Float"
  },
  es: {
    navStory: "Nuestra Historia",
    navHowItWorks: "Cómo funciona",
    navTravel: "Viajar como un Local",
    heroTitle: "Float,",
    heroSubtitle1: "La aplicación que",
    heroSubtitle2: "involucra a las personas para",
    heroSubtitle3: "viajar como un local",
    heroJoin: "ÚNETE AHORA",
    heroMeet: "y conoce gente",
    heroFrom: "de diferentes ciudades",
    howItWorksTitle1: "¿Cómo te ayuda la aplicación a encontrar tu",
    howItWorksTitle2: "amigo local",
    method1Title1: "Envía un Mensaje",
    method1Title2: "en una Botella",
    method1Desc: "Permitimos a los usuarios enviar mensajes en una botella a su grupo cultural o lingüístico elegido. Estos mensajes flotan en la \"zona de playa\", creando oportunidades para conexiones auténticas y fortuitas.",
    method2Title: "Descubre Respuestas de Todo el Mundo",
    method2Desc: "Explora respuestas reflexivas a tus botellas de hablantes nativos y entusiastas culturales. Participa en conversaciones significativas que fomentan el aprendizaje de idiomas y el intercambio cultural.",
    method3Title1: "Disfruta de",
    method3Title2: "Conversaciones Flotantes",
    method3Desc: "Experimenta una comunicación fluida a través de la traducción automática impulsada por IA. Float te conecta con personas de todo el mundo, rompiendo barreras y construyendo puentes entre culturas.",
    storytellersTitle: "Narradores",
    storytellersSubtitle: "Comparte Tesoros Locales a Través de Nuestra App",
    storytellersFeat1: "Comparte historias como \"漂流瓶\" (mensajes en una botella).",
    storytellersFeat2: "Destaca gemas ocultas y perspectivas culturales.",
    storytellersFeat3: "Construye conexiones globales significativas.",
    travelersTitle: "Viajeros",
    travelersSubtitle: "Explora sin Esfuerzo, Conecta Profundamente",
    travelersFeat1: "Evita la molestia de planificar: sigue tours curados.",
    travelersFeat2: "Descubre gemas ocultas a través de perspectivas locales.",
    travelersFeat3: "Sumérgete en experiencias culturales auténticas.",
    featuresTitle: "¿Cómo te ayuda la aplicación a encontrar tu amigo local?",
    feature1Title: "Aprendizaje Práctico de Idiomas",
    feature1Desc: "Float ayuda a los usuarios a practicar lenguaje casual y coloquial, rompiendo términos intermedios para su uso en el mundo real.",
    feature2Title: "Perspectivas Locales Auténticas",
    feature2Desc: "Los turistas pueden acceder a recomendaciones genuinas y sugerencias gastronómicas de locales para una experiencia de viaje más enriquecedora.",
    feature3Title: "Orientación sobre Etiqueta Cultural",
    feature3Desc: "Float proporciona normas culturales y consejos de etiqueta de locales, ayudando a los viajeros a evitar errores y convertirse en turistas respetuosos.",
    footerPartnership: "Consultas de asociación corporativa:",
    footerSocial: "Redes Sociales:",
    footerCopyright: "Copyright © 2025 Float"
  },
  fr: {
    navStory: "Notre Histoire",
    navHowItWorks: "Comment ça marche",
    navTravel: "Voyager comme un Local",
    heroTitle: "Float,",
    heroSubtitle1: "L'application qui",
    heroSubtitle2: "engage les gens à",
    heroSubtitle3: "voyager comme un local",
    heroJoin: "REJOIGNEZ MAINTENANT",
    heroMeet: "et rencontrez des gens",
    heroFrom: "de différentes villes",
    howItWorksTitle1: "Comment l'application vous aide-t-elle à trouver votre",
    howItWorksTitle2: "ami local",
    method1Title1: "Envoyez un Message",
    method1Title2: "dans une Bouteille",
    method1Desc: "Nous permettons aux utilisateurs d'envoyer des messages dans une bouteille à leur groupe culturel ou linguistique choisi. Ces messages flottent dans la \"zone de plage\", créant des opportunités de connexions authentiques et fortuites.",
    method2Title: "Découvrez des Réponses du Monde Entier",
    method2Desc: "Explorez des réponses réfléchies à vos bouteilles de locuteurs natifs et d'enthousiastes culturels. Participez à des conversations significatives qui favorisent l'apprentissage des langues et l'échange culturel.",
    method3Title1: "Profitez de",
    method3Title2: "Conversations Flottantes",
    method3Desc: "Découvrez une communication fluide grâce à la traduction automatique alimentée par l'IA. Float vous connecte avec des personnes du monde entier, brisant les barrières et construisant des ponts entre les cultures.",
    storytellersTitle: "Conteurs",
    storytellersSubtitle: "Partagez des Trésors Locaux via Notre App",
    storytellersFeat1: "Partagez des histoires sous forme de \"漂流瓶\" (messages dans une bouteille).",
    storytellersFeat2: "Mettez en valeur des joyaux cachés et des perspectives culturelles.",
    storytellersFeat3: "Construisez des connexions mondiales significatives.",
    travelersTitle: "Voyageurs",
    travelersSubtitle: "Explorez Sans Effort, Connectez-vous Profondément",
    travelersFeat1: "Évitez les tracas de planification—suivez des circuits organisés.",
    travelersFeat2: "Découvrez des joyaux cachés grâce aux perspectives locales.",
    travelersFeat3: "Plongez-vous dans des expériences culturelles authentiques.",
    featuresTitle: "Comment l'application vous aide-t-elle à trouver votre ami local?",
    feature1Title: "Apprentissage Pratique des Langues",
    feature1Desc: "Float aide les utilisateurs à pratiquer un langage décontracté et familier, brisant les termes intermédiaires pour une utilisation dans le monde réel.",
    feature2Title: "Perspectives Locales Authentiques",
    feature2Desc: "Les touristes peuvent accéder à de véritables recommandations et suggestions culinaires de la part des habitants pour une expérience de voyage plus enrichissante.",
    feature3Title: "Conseils sur l'Étiquette Culturelle",
    feature3Desc: "Float fournit des normes culturelles et des conseils d'étiquette des habitants, aidant les voyageurs à éviter les faux pas et à devenir des touristes respectueux.",
    footerPartnership: "Demandes de partenariat d'entreprise:",
    footerSocial: "Réseaux Sociaux:",
    footerCopyright: "Copyright © 2025 Float"
  },
  de: {
    navStory: "Unsere Geschichte",
    navHowItWorks: "Wie es funktioniert",
    navTravel: "Reisen wie ein Einheimischer",
    heroTitle: "Float,",
    heroSubtitle1: "Die App, die",
    heroSubtitle2: "Menschen dazu bringt,",
    heroSubtitle3: "wie ein Einheimischer zu reisen",
    heroJoin: "JETZT BEITRETEN",
    heroMeet: "und Menschen treffen",
    heroFrom: "aus verschiedenen Städten",
    howItWorksTitle1: "Wie hilft Ihnen die App, Ihren",
    howItWorksTitle2: "lokalen Freund zu finden",
    method1Title1: "Eine Nachricht senden",
    method1Title2: "in einer Flasche",
    method1Desc: "Wir ermöglichen es Benutzern, Nachrichten in einer Flasche an ihre gewählte Kultur- oder Sprachgruppe zu senden. Diese Nachrichten treiben in die \"Strandzone\" und schaffen Möglichkeiten für authentische und zufällige Verbindungen.",
    method2Title: "Entdecken Sie Antworten aus der ganzen Welt",
    method2Desc: "Erkunden Sie durchdachte Antworten auf Ihre Flaschen von Muttersprachlern und Kulturbegeisterten. Nehmen Sie an bedeutungsvollen Gesprächen teil, die das Sprachenlernen und den kulturellen Austausch fördern.",
    method3Title1: "Genießen Sie",
    method3Title2: "Schwebende Gespräche",
    method3Desc: "Erleben Sie nahtlose Kommunikation durch KI-gestützte automatische Übersetzung. Float verbindet Sie mit Menschen weltweit, durchbricht Barrieren und baut Brücken zwischen Kulturen.",
    storytellersTitle: "Geschichtenerzähler",
    storytellersSubtitle: "Teilen Sie lokale Schätze über unsere App",
    storytellersFeat1: "Teilen Sie Geschichten als \"漂流瓶\" (Nachrichten in einer Flasche).",
    storytellersFeat2: "Heben Sie verborgene Schätze und kulturelle Einblicke hervor.",
    storytellersFeat3: "Bauen Sie bedeutungsvolle globale Verbindungen auf.",
    travelersTitle: "Reisende",
    travelersSubtitle: "Mühelos erkunden, tief verbinden",
    travelersFeat1: "Überspringen Sie den Planungsaufwand—folgen Sie kuratierten Touren.",
    travelersFeat2: "Entdecken Sie verborgene Schätze durch lokale Einblicke.",
    travelersFeat3: "Tauchen Sie ein in authentische kulturelle Erlebnisse.",
    featuresTitle: "Wie hilft Ihnen die App, Ihren lokalen Freund zu finden?",
    feature1Title: "Praktisches Sprachenlernen",
    feature1Desc: "Float hilft Benutzern, lockere und umgangssprachliche Sprache zu üben und Zwischenbegriffe für die Verwendung in der realen Welt zu durchbrechen.",
    feature2Title: "Authentische lokale Einblicke",
    feature2Desc: "Touristen können auf echte Empfehlungen und Essensvorschläge von Einheimischen zugreifen, für ein bereicherndes Reiseerlebnis.",
    feature3Title: "Kulturelle Etikette-Anleitung",
    feature3Desc: "Float bietet kulturelle Normen und Etikette-Tipps von Einheimischen und hilft Reisenden, Fauxpas zu vermeiden und respektvolle Touristen zu werden.",
    footerPartnership: "Anfragen zu Unternehmenspartnerschaften:",
    footerSocial: "Soziale Medien:",
    footerCopyright: "Copyright © 2025 Float"
  }
};
